module.exports = __webpack_public_path__ + "img/webIcon.61652f9e.svg";